import React,{useEffect,useState} from 'react'
import { ThemeProvider } from "styled-components";
import {GlobalStyle} from './styles/Global';
import {LightTheme,DarkTheme} from './styles/Theme'
import { Route,Switch} from "react-router-dom";
import {Routes} from './Routes'
import { useSelector, useDispatch } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCartRequests } from './helpers/CartRequests'

import { setBasket } from './components/stores/Cart'

import axios from 'axios'

import {useHistory} from 'react-router-dom'

import ScrollButton from './components/Content/ScrollButton';

import NotFound from './views/NotFound'
import { useAuthRequests } from './helpers/AuthRequests';
import { setCustomer } from './components/stores/Auth';
import { Helmet } from 'react-helmet';

import fav1p from "./images/1.png";
import fav1 from "./images/gif/1.png";
import fav2 from "./images/gif/2.png";
import fav3 from "./images/gif/3.png";
import fav4 from "./images/gif/4.png";
import fav5 from "./images/gif/5.png";
import fav6 from "./images/gif/6.png";
import fav7 from "./images/gif/7.png";
import fav8 from "./images/gif/8.png";
import fav9 from "./images/gif/9.png";
import fav10 from "./images/gif/10.png";
import fav11 from "./images/gif/11.png";
import fav12 from "./images/gif/12.png";
import fav13 from "./images/gif/13.png";
import fav14 from "./images/gif/14.png";
import fav15 from "./images/gif/15.png";
import ScrollToTop from 'react-scroll-to-top';
import { ReactComponent as MyTestSvg } from "./MyTestSvg.svg";


function App() {
  const {  getCustomer } = useAuthRequests();


  const history=useHistory()
  const [mainRoutes,setMainRoutes]=useState(null)

  const getMainRoutes=()=>{
    Routes.then(res=>{
      
      setMainRoutes(res)
        
  })}




  useEffect(()=>{
    if(mainRoutes==null){
      getMainRoutes()
    }
  },[])

  const dispatch=useDispatch()

  const {login}=useSelector(state=>state.auth)

  const {theme}=useSelector(state=>state.site)

  const {basket}=useSelector(state=>state.cart)

  const {getCart} = useCartRequests()

  React.useEffect(()=>{
    
    if (login && basket == null) {
      getCustomer(localStorage.getItem("conteynertoken")).then((res) => {
        dispatch(setCustomer(res.data.data));
      });
      getCart().then((res) => {
        dispatch(setBasket(res.data.data));
      });
    }
  },[basket])

  

  axios.interceptors.response.use((response) => response, (error) => {
    try {
      if(error.response.status==401){
        //history.push('/giris-yap')

      }
    } catch (error) {
      
    }
    
    throw error;
  });

  const listRoutes=(routeList)=>{
      return routeList.map((route,index)=>{
                
        return(

          <Route key={`route-${route.path}`} path={route.path} exact={route.exact} component={route.component} />
        )

      })

  }
  const [icon,setIcon]=React.useState(fav1p)
  const icons = [
    fav1,
    fav2,
    fav3,
    fav4,
    fav5,
    fav6,
    fav7,
    fav8,
    fav9,
    fav10,
    fav11,
    fav12,
    fav13,
    fav14,
    fav15,
  ];

  // React.useEffect(()=>{
  //   setTimeout(() => {
  //     setIcon(icon == null ? 0 : icon >= 15 ? 0 : icon + 1);
  //   }, 300);
    
  // },[icon])

  return (
    <ThemeProvider theme={theme === "DarkTheme" ? DarkTheme : LightTheme}>
      <GlobalStyle />
      <ToastContainer />
      <Helmet>
        <link rel="icon" type="image/png" href={icon} />
      </Helmet>
      <ScrollButton />

      <Switch>
        {mainRoutes != null ? listRoutes(mainRoutes) : <></>}

        <Route path="*" render={() => <NotFound />} />
      </Switch>
      <ScrollToTop
        smooth
        className="go-top-btn"
        component={
          <>
            <MyTestSvg />
            <span>Yukarı Çık</span>
          </>
        }
      />
    </ThemeProvider>
  );
}

export default App;
